// extracted by mini-css-extract-plugin
export default {"termsWrapper":"terms_termsWrapper__DqGr3"};